import 'css-chunk:src/components/widgets/EmailAddressPicker/EmailIcon.scss';export default {
  "EmailIcon": "_EmailIcon_6tb90_1"
};